module.exports = __webpack_public_path__ + "static/media/img2-1.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/nutricheck_foliar/K/img2-1.png
// module id = 1046
// module chunks = 3